import React from 'react';
import { borderForUser } from '../../../utils/experience';
import './AvatarFrame.css';

/**
 * Wraps any avatar <img> in the border frame the user has earned:
 *
 *   <AvatarFrame user={u}><img className="navbar-avatar" ... /></AvatarFrame>
 *
 * The frame is a ring around whatever the child renders - the child
 * keeps its own size/classes. `border` overrides the computed frame
 * (the Experience page uses it to preview locked tiers).
 */
function AvatarFrame({ user, border, children, className = '' }) {
    const b = border || borderForUser(user);
    return (
        <span className={`pf-frame pf-${b.key}${className ? ` ${className}` : ''}`} title={b.key !== 'none' ? b.name : undefined}>
            {children}
        </span>
    );
}

export default AvatarFrame;
